import { render } from "./OnboardingStep.vue?vue&type=template&id=9de25144"
import script from "./OnboardingStep.vue?vue&type=script&lang=js"
export * from "./OnboardingStep.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__